import fitty from "fitty";
import React, { useEffect, useRef } from "react";
import { AVATAR_CDN } from "../../../constants/constants";

const EfficeIcon = ({ avatar_key, content }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      fitty(ref.current, {
        minSize: 6,
        maxSize: 16,
      });
    }
  }, [content]);
  const renderedContents = () => {
    if (avatar_key == null) {
      if (content) {
        if (content.length > 2) {
          return <div ref={ref}>{content[0] + content[1] + content[2]}</div>;
        } else if (content.length > 1) {
          return <div ref={ref}>{content[0] + content[1]}</div>;
        } else if (content.length > 0) {
          return <div ref={ref}>{content[0]}</div>;
        }
      }
      return <div>{""}</div>;
    } else {
      return (
        <div className="h-100 w-100 overflow-hidden">
          <img className="image-fill" src={AVATAR_CDN + avatar_key} alt="..." />
        </div>
      );
    }
  };

  return <div className="effice-icon">{renderedContents()}</div>;
};

export default EfficeIcon;
